// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";

// Import button
import Button from '../button/button';
import {Buffer} from 'buffer';
import { RateReviewOutlined } from "@mui/icons-material";

export default function Profile({profile, deleteProfile,boardProfiles,editClientRate}) {

	const [showInputBox, setShowInputBox] = useState(false);
	const [clientRate, setRate] = useState("");

	useEffect(() => {
		var rate = boardProfiles?.find(p => profile.id == p.id).rate;
		setRate(rate);
	},[])

    const onChange = () => {
        deleteProfile(profile.id);
    }

	const viewProfile = () => {
		window.open(`${window.location.origin}/profile?id=${Buffer.from(profile.id, "utf8").toString("base64")} `, "_blank");
	}

	const editRate = (e,id,type) => {
		setRate(e.target.value);
		if (e.keyCode === 13 || type== "blur") {
			if(editClientRate){
				setShowInputBox(false);
				editClientRate(e.target.value,id)
			}
		  }
		
	}

	return (
		// Function to render the content
	  	<div className="w-full h-auto relative mb-10 container ">
            <div className="col-span-12 flex absolute top-2 right-2">
                <Button value="Delete" buttonType="danger" className="btn" onClick={onChange} />
            </div>
			{/* Add card */}
			<div className="rounded-lg bg-grey-2 shadow-lg h-auto grid grid-cols-12 gap-0 p-6 box-border" >

				{/* Column for avatar */}
				<div className="col-span-12 flex items-center justify-center relative mt-5 cursor-pointer " onClick={() => viewProfile()}>
					
					{/* Render image if provided */}
					{
						profile && profile.image_url ?
						
						// Render imgae
						<img className="object-cove w-24 h-24 rounded-full" src={profile.image_url} /> : 
						
						// Render placeholder
						<div className="w-24 h-24 bg-white-3 flex items-center rounded-full">

							{/* Render text */}
							<div className="text-center w-full text-md font-text text-white-1 font-medium">{profile && profile.full_name[0].toUpperCase()}</div>
						
						</div>
					}

				</div>

				{/* Column for name and email and rate*/}
				<div className="col-span-12 grid grid-cols-12 gap-1 mt-3 cursor-pointer " onClick={() => viewProfile()}>

                    {/* Render name */}
                    <div className="w-full text-sm mb-2 font-text text-black-1 font-bold col-span-12 flex justify-center">{profile && profile.full_name}</div>

                    {/* Render email */}
                    { 
                    
					profile && profile.email ? <div className={`w-full mb-4 text-xs font-text text-black-1 flex items-center col-span-12 flex justify-center`}>

                            {/* Icon */}
                            <svg className="h-3 w-3 fill-current text-black-1 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"/></svg>
                        
                            {/* Text */}
                            {profile.email}
                            
                        </div>	

                        : null

                    }
					<div className="col-span-2"></div>

					{/* Hourly rate */}
					<div className={`mb-4 text-sm text-black-1 col-span-7`}>
						<div className="flex justify-between">
							<div className="font-medium">Pricing:</div>
							<div className={`font-semibold text-grey-6  ${showInputBox ? "" : "mr-3"}`}>${profile.expected_hourly_rate}</div>	
						</div>	
					</div>	
					<div className="col-span-3"></div>

				</div>

				{/* For client pricing */}
				<div className="col-span-2"></div>

				{/* Hourly rate */}
				<div className={`mb-2 text-sm text-black-1 col-span-8`}>
					<div className="flex justify-between">
						<div className="font-medium">Client pricing:</div>
						{
							showInputBox ?
							<input type="number" value={clientRate} autoFocus onChange={(e) => editRate(e,profile.id,"")} onKeyDown={(e) => e.keyCode === 13 && editRate(e,profile.id,"enter")} onBlur={(e) => editRate(e,profile.id,"blur")} style={{"textAlign":'center', "color" : "blue"}} className="-mt-1 bg-white-7 border border-blue-1 w-16 h-7 flex items-center rounded focus:border-blue-1 focus:border-2 focus:outline-none" />  
							: <div className="font-semibold text-blue-1 flex mr-1">${clientRate}
								<span className="ml-3 cursor-pointer" onClick={()=> setShowInputBox(true)}><img src="edit.png" /> </span>	
							</div>
						}
							
					</div>	
				</div>	
				<div className="col-span-2"></div>

			</div>

	  	</div>
    )

}